import { render, staticRenderFns } from "./printsign.vue?vue&type=template&id=661441fc&scoped=true&"
import script from "./printsign.vue?vue&type=script&lang=js&"
export * from "./printsign.vue?vue&type=script&lang=js&"
import style0 from "./printsign.vue?vue&type=style&index=0&id=661441fc&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661441fc",
  null
  
)

export default component.exports